module.exports = __webpack_public_path__ + "12f790adb99e408d7d765835d4121252.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatars/avatar-3.png
// module id = 307
// module chunks = 1